<template>
	<div class="sign">
		<div class="sign-item">
			<div class="item-top">
				<div>
					<p>货柜号</p>
					<p>{{list.containerNo}}</p>
				</div>
				<div>
					<p>待拣货数量</p>
					<p>{{list.waitPickQty}}</p>
				</div>
			</div>
			<template v-if="list">
				<ul class="bale-sku">
					<li @click="toPickingDetail(item)" v-for="(item,index) in list.skuList" :key="index">
						<div>
							<div class="sign-list">
								<p>SKU：{{item.skuCode}}</p>
								<p>发货编码：{{item.sourceNo}}</p>
							</div>
							<div class="sign-list">
								<p>拣货进度：{{item.pickQty}}/{{item.quantity}}</p>
								<p>创建时间：{{item.createTimeDesc}}</p>
							</div>
						</div>
					</li>
				</ul>
			</template>
			<template v-else>
				<van-empty image="search" description="暂无数据" />
			</template>
		</div>
	</div>
</template>

<script>
import { Icon, Badge, Picker, Popup, Field, Toast, Empty, List, Loading, Checkbox, Tab, Tabs } from 'vant';
import { GetWaitPickContainerNoQuerySku } from '@/api/mobile/picking_api';
import { mapState, mapMutations } from 'vuex'
import util from "util/date";
import { debounce } from "util/util";
import { mixins } from "../mobileMixins";

export default {
	data() {
		return {
			search: {
				containerNo: '',
				stockingTaskID: ''
			},
			list: [],
			loading: false,
			tabType: 'sku'
		}
	},

	components: {
		[Icon.name]: Icon,
		[Badge.name]: Badge,
		[Picker.name]: Picker,
		[Popup.name]: Popup,
		[Toast.name]: Toast,
		[List.name]: List,
		[Empty.name]: Empty,
		[Loading.name]: Loading,
		[Checkbox.name]: Checkbox,
		[Tab.name]: Tab,
		[Tabs.name]: Tabs,
		[Field.name]: Field
	},

	mixins: [mixins],

	created() {
		this.init()
	},

	computed: {
		...mapState({ warehouse: state => state.common.warehouse })
	},

	methods: {
		...mapMutations({
			saveMobileTitle: 'saveMobileTitle'
		}),
		init() {
			// const _warehouse = window.localStorage.warehouse ? JSON.parse(window.localStorage.warehouse) : this.warehouse;
			// this.$set(this.search, 'warehouseId', _warehouse.warehouseId)

			this.saveMobileTitle(window.localStorage.mobileTitle)

			this.getList()
		},
		getList() {
			const that = this

			const { containerNo, stockingTaskID } = this.$route.query

            const _warehouse = JSON.parse(window.localStorage.warehouse)
		
			const data = {
				containerNo, stockingTaskID
			}

            data.warehouseId=_warehouse.warehouseId;

			GetWaitPickContainerNoQuerySku(data).then(res => {
				if (res.status === 200) {
					const { response } = res

					if(!response.skuList.length){
						setTimeout(function(){
							that.$router.go(-1)
						},1500)
					}

					this.list = response
				} else {
					Toast.fail(res.msg);
				}
			})
		},
		toPickingDetail(item) {
			const {  shippingPlanDetailID, shippingPlanID, skuCode, productID } = item
			const { stockingTaskID } = this.list
			this.$router.push({ path: '/mobile/pickingDetail', query: { shippingPlanDetailID, shippingPlanID, skuCode, productID, stockingTaskID } })
		}
	},

	watch: {
		$route: async function (newValue, from) {
			this.$nextTick(() => {
			})
		},
	}
}
</script>

<style lang="less" scoped>
@import "../../../style/mobile_common.less";

.sign-search .toSearch-box {
	flex: 0.4;
	margin-left: 3%;
	min-height: 90px;
}

.sign-toSearch {
	width: 100%;
	height: 65%;
	min-height: 80px;
	border-radius: 5px;
	border: 0;
	color: #fff;
	font-size: 20px;
}

::v-deep .van-tabs__nav--card {
	margin: 0;
	border: 0;
}

.sign-item .bale-container li {
	display: flex;
	height: 40px;
	line-height: 40px;
	& > div {
		flex: 1;
		text-align: center;
	}
}
.item-top {
	display: flex;
	border-bottom: 1px solid #ccc;
	& > div {
		flex: 1;
		display: flex;
		align-items: center;
		flex-direction: column;
	}
}
.sign-list {
	padding-left: 5%;
}
p {
	margin: 5px 0;
}
</style>